import CoursesSetupDetails from "./CoursesSetupDetails";

export default CoursesSetupDetails;